import React from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

export default function TrainingBlogDetail() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { state } = useLocation();
  console.log(state, "Blog Data");

  const partner = state?.partner;

  return (
    <div className="container-fluid justify-content-center px-3">
      <div className="mt-3">
        <div
          className="card shadow-md p-4 mt-3 mb-4 about-content"
          style={{ marginLeft: "14px" }}
        >
          {/* Blog Title */}
          <h4 className="fw-bold mb-4">{partner?.title || partner?.name}</h4>

          {/* Blog Image */}
          {state?.blog?.logo && (
            <div className="mb-4 img-detail-interview">
              <img src={state.blog.logo} alt="Blog" />
            </div>
          )}

          {/* Blog Website (Shown only if available) */}
          {partner?.website && (
            <>
              <h6 className="fw-bold">Blog Website</h6>
              <p>
                <a
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "blue",
                    fontWeight: "bold",
                  }}
                >
                  {partner.website}
                </a>
              </p>
            </>
          )}

          {/* Blog Description (Shown only if available) */}
          {partner?.description && (
            <>
              <h6 className="fw-bold">Blog Description</h6>
              <p>{partner.description}</p>
            </>
          )}

          {/* Render Courses only if they exist */}
          {partner?.courses?.length > 0 && (
            <div>
              {partner.courses.map((course, index) => (
                <div key={index} className="course-section">
                  <h6 className="fw-bold">{course.title}</h6>
                  <p>{course.description}</p>

                  {/* Course Link (Shown only if available) */}
                  {course.course_link && (
                    <h6 className="fw-bold">Course Link</h6>
                  )}

                  {course.course_link && (
                    <a
                      style={{ color: "blue" }}
                      href={course.course_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {course.course_link}
                    </a>
                  )}

                  {/* Render Modules only if they exist */}
                  {course.modules?.length > 0 && (
                    <>
                      <h6 className="fw-bold mt-2">Modules</h6>
                      <ul>
                        {course.modules.map((module, i) => (
                          <li key={i}>{module}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
